import user from "./user";
import transcription from "./transcription";
import question from "./question";
import summary from "./summary";

export default {
  user,
  transcription,
  question,
  summary
};